import { heroStats, updates } from "@/mocks/homeContent";

export default function Hero() {
  const goUpdate = () => document.querySelector("#updates")?.scrollIntoView({ behavior: "smooth" });
  const goHot = () => document.querySelector("#hot")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative overflow-hidden">
      {/* 环境光氛围 */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-gradient-to-r from-primary-200/50 via-accent-100/60 to-primary-200/40 blur-3xl"></div>
        <div className="absolute right-[-10rem] top-40 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-[-8rem] h-64 w-64 rounded-full bg-primary-100/40 blur-3xl"></div>
      </div>

      {/* 顶部通栏提示 */}
      <div className="mx-auto mt-16 w-full max-w-6xl px-4 pt-4 md:mt-[4.5rem] md:px-6">
        <div className="flex items-center gap-2 rounded-full border border-accent-200/70 bg-accent-100/60 px-4 py-2 text-xs font-medium text-accent-900 md:px-5 md:text-sm">
          <span className="relative flex h-2 w-2 shrink-0">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
          <span className="whitespace-nowrap">吃瓜网址换地址了，本页即为最新可用入口</span>
          <button
            onClick={goUpdate}
            className="ml-auto inline-flex shrink-0 items-center whitespace-nowrap font-semibold text-accent-800 hover:text-accent-950"
          >
            看更新动态
            <i className="ri-arrow-right-line ml-1 text-sm leading-none"></i>
          </button>
        </div>
      </div>

      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 pb-14 pt-8 md:px-6 lg:grid-cols-[1.35fr_1fr] lg:pb-20 lg:pt-12">
        {/* 左：文案优先 */}
        <div className="flex flex-col justify-center">
          <p className="mb-4 inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1 text-xs font-semibold tracking-wide text-primary-700">
            <i className="ri-flashlight-fill text-sm leading-none"></i>
            吃瓜网址最新发布 · 2026-09-07 已换新址
          </p>
          <h1 className="font-heading text-3xl font-black leading-[1.18] tracking-tight text-foreground-950 md:text-5xl">
            吃瓜网址换地址了，
            <br className="hidden sm:block" />
            本页是此刻<span className="text-primary-600">不会掉线</span>的新入口。
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            从剧组路透到商战对线，从发布翻车到转会传闻——吃瓜网址新地址已同步上线。别在旧链接里打转，认准首页新入口，今日热榜、圈层专题与短讯速览一处吃透。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={goHot}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-fill mr-2 text-base leading-none"></i>
              去看今日热榜
            </button>
            <button
              onClick={() => document.querySelector("#topics")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-secondary-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-secondary-100"
            >
              <i className="ri-stack-fill mr-2 text-base leading-none"></i>
              浏览专题合集
            </button>
          </div>

          {/* 状态指标 */}
          <div className="mt-8 flex items-center gap-6 border-t border-secondary-200 pt-5 md:gap-10">
            {heroStats.map((s) => (
              <div key={s.label}>
                <div className="font-display text-2xl font-normal tracking-wide text-foreground-950 md:text-3xl">
                  {s.value}
                </div>
                <div className="mt-0.5 text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 右：入口状态面板（视觉陪衬） */}
        <aside className="flex flex-col">
          <div className="rounded-2xl border border-secondary-200/80 bg-background-50/80 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-send-plane-fill text-sm leading-none"></i>
                </span>
                本站入口状态
              </h2>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-700">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm leading-none"></i>
                运行正常
              </span>
            </div>

            <ul className="mt-4 space-y-3">
              {updates.slice(0, 3).map((u) => (
                <li
                  key={u.id}
                  className="flex items-start gap-3 rounded-xl border border-secondary-100 bg-background-100/60 px-3.5 py-3"
                >
                  <span
                    className={`mt-1 flex h-2 w-2 shrink-0 rounded-full ${
                      u.kind === "入口" ? "bg-primary-500" : u.kind === "同步" ? "bg-accent-500" : "bg-secondary-400"
                    }`}
                  ></span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-foreground-900">{u.title}</p>
                    <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">{u.note}</p>
                  </div>
                </li>
              ))}
            </ul>

            <button
              onClick={goUpdate}
              className="mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-lg border border-secondary-200 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-800"
            >
              查看完整更新动态
              <i className="ri-arrow-right-line text-sm leading-none"></i>
            </button>
          </div>

          <p className="mt-4 text-center text-xs text-foreground-400">
            认准「吃瓜网址新地址」标识，追瓜不迷路
          </p>
        </aside>
      </div>
    </section>
  );
}